<template>
  <div class="lead-update-monitor">
    <div class="lead-update-monitor--section">
      <div class="lead-update-monitor--advancement">
        <div class="progress">
          <progress-bar :percentage="progress" :isMini="true"></progress-bar>
          <span class="progress-percentage">{{progress.toFixed()}}%</span>
        </div>
        <div
          class="progress-complete"
          v-if="progress == 100"
        >{{$t('models.project_lead.progress_complete')}}</div>
        <lead-update-crm-status
          v-if="item.sync_status"
          :class="{ 'inactive-status' : item.sync_status == 'sync_ready' && $store.getters.getOrganizationConfig('crm_presence') == false }"
          :structure="structure"
          :lead="item"
        ></lead-update-crm-status>
      </div>
    </div>
    <div class="lead-update-monitor--section no-padding">
      <div
        :class="[{'bordered': item.businesscard_image_url}, 'lead-update-monitor--business-card']"
      >
        <lead-update-business-card @openBusinessCard="openBusinessCard" :lead="item"></lead-update-business-card>
      </div>

    </div>
    <div class="lead-update-monitor--section">
      <div class="classification-container">
        <field
          type="radio"
          :collection="classificationCollection"
          :value="item.classification"
          :model="item.classification"
          @input="inputClassification"
          :label="$t('models.project_lead.classification')"
          :params="{'no_i18n': true}"
          model="project_lead"
          class="is-buttonned"
        />
      </div>
      <div class="classification-container" v-if="allowedLeadReview()">
        <field
          type="radio"
          :collection="statusCollection"
          :value="item.status"
          :model="item.status"
          @input="inputStatus"
          :label="$t('models.project_lead.status')"
          :params="{'no_i18n': true}"
          model="project_lead"
          class="is-buttonned"
        />
      </div>
      <div class="capturer">
        <div class="label">{{$t('models.project_lead.capturer')}}</div>
        <!-- Encapsulate to component -->
        <user-image
          :firstname="item.user_firstname"
          :lastname="item.user_lastname"
          :email="item.user_email"
          theme="sensual-lighter"
        />
        <div class="capturer-name" v-if="userData()">
          <p class>{{userData()}}</p>
        </div>
        <div class="capturer-name" v-else>{{$t('models.project_lead.capturer_unknown')}}</div>
      </div>
      <div class="crm-switch">
        <form-switch
          v-if="showCrmSyncSwitch()"
          @input="inputCrmSync"
          :reverse="true"
          name="sync_disabled"
          :value="item.sync_disabled"
          model="project_lead"
        />
      </div>
      <div v-if="item.start_date">
        <p class="caption">
          {{$t('models.project_lead.start_date')}}
          {{date(item.start_date)}}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ProgressBar from "@/components/helpers/DataDisplay/ProgressBar";
import ProjectApi from "@/api/Project.js";
import Field from "@/components/helpers/DataInput/Field";
import UserApi from "@/api/User";
import LeadUpdateBusinessCard from "./LeadUpdateBusinessCard";
import LeadUpdateCrmStatus from "./LeadUpdateCrmStatus";
import FormSwitch from "@/components/helpers/DataInput/FormSwitch";
import UserImage from "@/components/helpers/Specific/UserImage";

export default {
  components: {
    ProgressBar,
    Field,
    LeadUpdateBusinessCard,
    LeadUpdateCrmStatus,
    FormSwitch,
    UserImage
  },
  props: {
    item: Object,
    type: String,
    progress: Number,
    errors: Array,
    structure: Object,
    leadReviewEnabled: Boolean
  },
  data() {
    return {
      selectClass: "",
      popupVisible: false,
      showUpdateMonitor: false
    };
  },
  computed: {
    classificationCollection() {
      return [
        {
          name: this.$t("models.select_classification.hot"),
          value: "hot",
          color: "red"
        },
        {
          name: this.$t("models.select_classification.warm"),
          value: "warm",
          color: "orange"
        },
        {
          name: this.$t("models.select_classification.cold"),
          value: "cold",
          color: "blue"
        }
      ];
    },

    statusCollection() {
      let statusCollection = [
        {
          name: this.$t("models.select_status.review"),
          value: "review",
          color: "orange"
        },
        {
          name: this.$t("models.select_status.active"),
          value: "active",
          color: "green"
        }
      ];

      if (this.$store.getters.getCurrentUserIsRoot) {
        statusCollection.unshift({
          name: this.$t("models.select_status.pre_review"),
          value: "pre_review",
          color: "orange"
        });
      }

      return statusCollection;
    }
  },
  methods: {
    date(value) {
      return moment(value).format("DD MMM YYYY");
    },
    inputClassification(value) {
      if (!value) {
        value = "unclassified";
      }
      this.$emit("input", "classification", value);
    },
    inputStatus(value) {
      this.$emit("input", "status", value);
    },
    inputUserId(value) {
      this.$emit("input", "user_id", value);
    },
    inputStartDate(value) {
      this.$emit("input", "start_date", value);
    },
    inputCrmSync(value) {
      this.$emit("input", "sync_disabled", value);
    },
    openBusinessCard() {
      this.$emit("openBusinessCard");
    },
    userData() {
      if (this.item.user_email == "unknown") {
        return null;
      } else {
        if (
          (this.item.user_firstname == "" && this.item.user_lastname == "") ||
          (!this.item.user_firstname && !this.item.user_lastname)
        ) {
          return this.item.user_email;
        } else {
          return `${this.item.user_firstname} ${this.item.user_lastname}`;
        }
      }
    },
    userInitials() {
      if (this.item.user_email == "unknown") {
        return "?";
      } else {
        if (
          (this.item.user_firstname == "" && this.item.user_lastname == "") ||
          (!this.item.user_firstname && !this.item.user_lastname)
        ) {
          return "?";
        } else {
          return `${this.item.user_firstname.charAt(
            0
          )}${this.item.user_lastname.charAt(0)}`;
        }
      }
    },
    allowedLeadReview() {
      return (
        this.$store.getters.getCurrentUserIsAdmin && this.leadReviewEnabled
      );
    },
    showCrmSyncSwitch () {
      return this.$store.getters.getOrganizationConfig('crm_presence') || this.$store.getters.getOrganizationConfig('enable_crm_sync_switches')
    }
  }
};
</script>

<style lang="scss" scoped>
.inactive-status {
  display: none !important;
}
.lead-update-monitor {
  .capturer-name {
    display: inline-block;
    position: relative;
    padding-left: 10px;
    p {
      color: $ink-light;
      margin-bottom: 0px;
    }
  }

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  padding: 10px 0px 10px 0px;
  border-radius: 5px;

  .lead-update-monitor--section {
    padding: 0px 30px 0px 30px;
    .no-padding {
      padding: 0;
    }
  }

  .progress {
    padding-top: 1em;
  }

  .label {
    color: $ink;
    font-weight: $font-medium;
    font-size: 15px;
    line-height: 24px;
  }
  .form-switch {
    align-items: center;
    margin-bottom: 1em;
    label {
      margin-top: 10px;
      color: $ink;
      margin-right: 15px;
    }
  }
  .missing-fields {
    margin-top: 0.5em;
    b {
      color: #d00019;
      font-weight: 400;
    }
    span {
      color: #d00019;
    }
  }

  .capturer {
    margin: 0px 0px 20px 0px;
  }
}

.lead-update-monitor--business-card {
  margin: 24px 0px 24px 0px;
  text-align: center;
  border: 1px solid $paper;
  &.bordered {
    border: 1px solid $paper;
  }
}

.lead-update-monitor--advancement .progress {
  display: flex;
  .progress-bar-container {
    flex-grow: 12;
    align-self: center;
    .progress-bar {
      margin-bottom: 0;
    }
  }
  span {
    // flex-grow: 1;
    padding-left: 0.5em;
    text-align: right;
  }
}

// how it is displayed on tablet + mobile
.lead-update-monitor.outside-content {
  margin: 0;
  padding: 0;
  .lead-update-monitor--advancement,
  .lead-update-monitor--more {
    align-self: center;
    padding-top: 0.5em;
    .field:first-child {
      margin-top: 0;
    }
  }
  .missing-fields {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .field--wrapper {
    margin-left: 0;
  }
}

// how it is displayed on desktop
.lead-update-monitor.inside-content {
  background: $paper-lighter;
  @include respond-to("large-up") {
    display: block;
  }
  .lead-update-monitor--business-card,
  .lead-update-monitor--advancement,
  .lead-update-monitor--more {
    width: auto;
    display: block;
  }

  .last-line {
    > div {
      align-self: center;
    }
    .date-container {
      flex-grow: 5;
    }
  }
}

.progress-percentage {
  display: inline-block;
  width: 45px;
  font-size: 12px;
}

.progress-complete {
  font-size: 12px;
}

.preview-bar {
  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .lead-update-monitor--trigger {
    font-size: 16px;
    margin-right: 24px;
    margin-top: 0.75em;
    font-weight: 400;
    .icon {
      vertical-align: middle;
    }
  }
}

.lead-update-monitor--popup-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow-y: auto;
}

.lead-update-monitor--popup {
  width: 70%;
  position: absolute;
  left: 15%;
  top: 220px;
  background: #fff;
  padding: 20px;
  margin-bottom: 50px;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.51);
  border-radius: 3px;
}

.lead-update-monitor--popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  h3 {
    margin-bottom: 0;
    font-weight: 400;
  }
}
.lead-update-monitor {
  max-height: fit-content;
  .modal-box--closing-button {
    cursor: pointer;
    position: static;
  }
}

.outside-content {
  margin-top: -30px;
  padding-bottom: 8px;
  @include respond-to("medium") {
    margin-top: 8px;
  }
  .lead-update-monitor--business-card {
    background: $paper-light;
    margin-left: -20px;
    margin-right: -20px;
    padding: 20px;
    padding-left: 20%;
    padding-right: 20%;
  }
  .lead-update-monitor--more,
  .lead-update-monitor--advancement {
    padding-left: 20%;
    padding-right: 20%;
  }
}
.crm-switch {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// LeadUpdateMonitor.vue?db1bc7f8